import Vue from 'vue'
import App from './App.vue'
import 'amfe-flexible/index.js'
import router from './router'
import store from './store'
import '@/elements'
import apiFun from "@/api/index.js"
import ModalBox from '@/components/ModalBox'
import {MessageBox} from 'element-ui'
import { Message } from 'element-ui'
import * as moment from 'moment';
import Print from './utils/print'
Vue.use(Print)
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$apiFun = apiFun//请求接口api
Vue.prototype.$moment = moment
Vue.prototype.$message = Message;
//引入全局ui样式
import '@/assets/style/qx.main.scss'
import '@/assets/style/global.scss'
import '@/permission'
Vue.component('modal-box', ModalBox)
Vue.config.productionTip = false



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
